import styled from "styled-components";
import { colors } from "../element/elements.js";

export const Styles = styled.div`

    .bitHeader-area {        
        background-size    : cover;
        background-position: right;
        background-repeat  : no-repeat;
        padding            : 60px 0;
        position           : relative;

        &:before {
            position  : absolute;
            content   : '';
            opacity   : 0.5;
            width     : 100%;
            height    : 100%;
            top       : 0;
            left      : 0;
        }

        h2{
            color: ${colors.white};
            font-weight: 500;
            padding-bottom: 10px;
            margin-bottom: 15px;
            position: relative;
            padding   : 30px 45px 10px 0;
            &:before {
                position: absolute;
                content: "";
                background: ${colors.bg3};
                width: 50px;
                height: 3px;
                bottom: 0;
                left: 0;
            }

            @media(max-width: 767px) {
                font-size : 20px;
            }
        }
    }
`;